export const ff_facility_ui_ratecardtab = 'ff_facility_ui_ratecardtab';
export const ff_facility_ui_edit_internal_contacts = 'ff_facility_ui_edit_internal_contacts';
export const ff_facility_ui_newpreference_rfo_to_sent = 'ff_facility_ui_newpreference_rfo_to_sent';
export const ff_unit_ui_newpreference_rfo_to_sent = 'ff_unit_ui_newpreference_rfo_to_sent';
export const ff_unit_ui_duplicate_skill_set = 'ff_unit_ui_duplicate_skill_set';